// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import checkRtlLanguage from '../../utils/checkRtlLanguage';
import { reviewsConfig } from './config';

import * as styles from './FacebookTestimonialsContainer.scss';

class FacebookTestimonialsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberComment: 0
    };
  }

  nextComment = () => {
    if (reviewsConfig.length === (this.state.numberComment + 1)) {
      this.setState({ numberComment: 0 });
    } else {
      this.setState({ numberComment: this.state.numberComment + 1 });
    }
  };

  renderReview = () => {
    const { numberComment } = this.state;
    const { name, photo, message } = reviewsConfig[numberComment];

    return (
      <div className={styles.message} onClick={this.nextComment}>
        <div className={styles.userPhoto}>
          <img src={photo} alt="userPhoto" />
        </div>
        <p className={styles.userName}>{name}</p>
        <p>{message}</p>
      </div>
    );
  };

  render() {
    return (
      <div className={styles.messagesContainer}>
        <div className={styles.messagesWrapper}>
          <h2>{this.props.translate('facebookTestimonials', 'title')}</h2>
          <div className={styles.messagesItem}>
            {this.renderReview()}
          </div>
        </div>
      </div>
    );
  }
}

FacebookTestimonialsContainer.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'RealtorLanding'),
  locale: state.lang.locale,
  isMobile: state.windowDimentions.isMobile,
  isRtl: checkRtlLanguage(state.lang.locale)
});

export default connect(mapStateToProps)(FacebookTestimonialsContainer);
